import { useEffect, useState } from "react";
import { Activity as ActivityIcon, Sparkles, CheckCircle2, XCircle, ImageOff } from "lucide-react";
import api from "@/lib/api";
import { CinematicStage, StageHeader, GlassCard, EmptyState, Spinner } from "@/components/shared";

const ICONS = {
  pipeline_started: Sparkles, pipeline_completed: CheckCircle2, pipeline_failed: XCircle,
  scene_image_failed: ImageOff, character_image_failed: ImageOff,
};
const LABELS = {
  pipeline_started: "Production started", pipeline_completed: "Production completed",
  pipeline_failed: "Production failed", scene_image_failed: "Scene image failed",
  character_image_failed: "Character image failed",
};

export default function ActivityPage() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/activity").then(({ data }) => setLogs(data)).catch(() => setLogs([])); }, []);
  if (!logs) return <Spinner label="Loading Activity…" />;

  const fmt = (t) => { try { return new Date(t).toLocaleString(); } catch { return t; } };

  return (
    <CinematicStage>
      <StageHeader stage="OPS" room="The Log Book · Activity" icon={ActivityIcon} title="Everything your studio does, logged"
        subtitle="Pipeline runs, rendering steps and generation events." />
      {logs.length === 0 ? (
        <EmptyState icon={ActivityIcon} title="No activity yet" subtitle="Run a production to see the timeline here." />
      ) : (
        <GlassCard className="p-2">
          <div className="divide-y divide-white/5">
            {logs.map((l, i) => {
              const Icon = ICONS[l.event] || ActivityIcon;
              return (
                <div key={i} className="flex items-center gap-4 p-4" data-testid="activity-item">
                  <div className="w-9 h-9 rounded-xl bg-[#5B4DFF]/15 grid place-items-center shrink-0"><Icon className="w-4 h-4 text-[#5B4DFF]" /></div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-white">{LABELS[l.event] || l.event}</div>
                    {l.detail && <div className="text-xs text-slate-500 truncate">{l.detail}</div>}
                  </div>
                  <div className="text-xs text-slate-600 font-mono whitespace-nowrap">{fmt(l.created_at)}</div>
                </div>
              );
            })}
          </div>
        </GlassCard>
      )}
    </CinematicStage>
  );
}
